var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdLogo21X21(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.476 19.28a8.737 8.737 0 0 1-6.808-3.262 8.788 8.788 0 0 1-1.751-7.357v-.492l.087.118 2.824 3.873h.34l2.976-3.98v6.651h1.72V5.665h-1.97L5.032 9.609 2.722 6.424l-.548-.76h-.997A10.524 10.524 0 0 0 .46 13.58a10.494 10.494 0 0 0 5.02 6.15 10.449 10.449 0 0 0 7.88.863 10.478 10.478 0 0 0 6.226-4.92h-2.045a8.753 8.753 0 0 1-7.066 3.606z",
    fill: "#85B440"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.87 9.195a10.51 10.51 0 0 0-2.584-5.694A10.466 10.466 0 0 0 12.93.291c-2.069-.499-4.24-.354-6.225.415a10.476 10.476 0 0 0-4.886 3.89h2.184a8.737 8.737 0 0 1 13.19.279 8.792 8.792 0 0 1 1.97 4.513c.106.447.128.911.065 1.367-.176 1.27-1.034 2.401-2.825 2.401h-1.88V7.288h1.88a3.004 3.004 0 0 1 1.564.392c-.162-1.02-.537-1.643-.798-1.979a5.914 5.914 0 0 0-.766-.05h-3.59v9.168h3.59c.637.008 1.27-.1 1.867-.32 1.667-.635 2.522-2.13 2.677-3.715a5.409 5.409 0 0 0-.077-1.59z",
    fill: "#32324D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdLogo21X21);
export default __webpack_public_path__ + "static/media/MD_Logo_21x21.6e425426fdfbada8b4f124b74fa42da2.svg";
export { ForwardRef as ReactComponent };